import { render, staticRenderFns } from "./ConsolidationUnionTable.vue?vue&type=template&id=6dd9b053&scoped=true"
import script from "./ConsolidationUnionTable.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9b053",
  null
  
)

export default component.exports